import { Modal } from "components";
import moment from "moment";
import React, { createRef } from "react";
import { ClickableCalendarAppointment } from "./CalendarAppointment";
import { useCustomQuery, useIsOverflow } from "utilities/hookutils";
import { Loading } from "components/panels";
import { NoDataAvailableDiv } from "components/NoDataAvailableDiv";
import { AxiosPromise } from "axios";
import { formatWrittenDayMonthYear } from "utilities";

interface CalendarAppointmentModalProps {
  scheduleForDay: server.dto.AppointmentsDayGroup;
  onClose: () => void;
  filterSet: server.dto.FilterSets;
  fetchFunction: (day: moment.Moment) => AxiosPromise<server.dto.ApiResponseWrapperWithRequest<server.dto.AppointmentForPlanner[], any>>;
}

export const CalendarAppointmentModal = (props: CalendarAppointmentModalProps) => {
  const dayMoment = moment.utc(props.scheduleForDay.day);
  const ref = createRef<HTMLDivElement>();
  const isOverflow = useIsOverflow(ref, "calendarAppointmentModal");

  const api = useCustomQuery({
    queryFn: async () => {
      return await props.fetchFunction(dayMoment);
    },
    queryKey: [props.filterSet, "day", dayMoment.format("YYYY-MM-DD")],
    cacheTime: 0,
  });

  const data = api.data?.data?.data ?? [];

  return <Modal
    isOpen
    handleClose={props.onClose}
    width="large"
    height={700}
    title={formatWrittenDayMonthYear(dayMoment)}
  >
    {api.isInitialLoading && <Loading />}
    {!api.isLoading && data.length === 0 && <NoDataAvailableDiv />}

    {data.length > 0 && <div
      ref={ref}
      style={{ paddingRight: isOverflow ? `${12}px` : undefined }}
      className="list-with-gaps card-layout overflow-y"
    >
      <div className="list-with-gaps-body">
        {data.map(item =>
          <ClickableCalendarAppointment
            key={item.id}
            appointment={item}
          />
        )}
      </div>
    </div>}
  </Modal>
};